import { ReactElement } from 'react';
import testEnv from 'src/tests/test-env';
import NavigationBar from './navigation-bar/navigation-bar';
import Loading from './overlay/loading';

const MainLayout = ({
  children,
  isLoading = false,
}: {
  children: ReactElement | ReactElement[];
  isLoading?: boolean;
}) => {
  return (
    <div className="pb-[50px] flex flex-col">
      {!testEnv.isTestMode ? <NavigationBar /> : undefined}
      {children}
      {isLoading && <Loading />}
    </div>
  );
};

export default MainLayout;
